// Generated by purs version 0.15.15
var UserSpaceOnUse = /* #__PURE__ */ (function () {
    function UserSpaceOnUse() {

    };
    UserSpaceOnUse.value = new UserSpaceOnUse();
    return UserSpaceOnUse;
})();
var StrokeWidth = /* #__PURE__ */ (function () {
    function StrokeWidth() {

    };
    StrokeWidth.value = new StrokeWidth();
    return StrokeWidth;
})();
var showMarkerUnit = {
    show: function (v) {
        if (v instanceof UserSpaceOnUse) {
            return "UserSpaceOnUse";
        };
        if (v instanceof StrokeWidth) {
            return "StrokeWidth";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.MarkerUnit (line 15, column 10 - line 17, column 33): " + [ v.constructor.name ]);
    }
};
var printMarkerUnit = function (v) {
    if (v instanceof UserSpaceOnUse) {
        return "userSpaceOnUse";
    };
    if (v instanceof StrokeWidth) {
        return "strokeWidth";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.MarkerUnit (line 20, column 19 - line 22, column 31): " + [ v.constructor.name ]);
};
var eqMarkerUnit = {
    eq: function (x) {
        return function (y) {
            if (x instanceof UserSpaceOnUse && y instanceof UserSpaceOnUse) {
                return true;
            };
            if (x instanceof StrokeWidth && y instanceof StrokeWidth) {
                return true;
            };
            return false;
        };
    }
};
export {
    UserSpaceOnUse,
    StrokeWidth,
    printMarkerUnit,
    eqMarkerUnit,
    showMarkerUnit
};
